import { Header1, Text } from '@ardoq/typography';
import { ReactNode } from 'react';
import { Box } from '../Box/Box';

type HeaderProps = {
  title: string;
  subtitle?: string | ReactNode;
};

export const Header = ({ title, subtitle }: HeaderProps) => (
  <>
    <Header1>{title}</Header1>
    {subtitle && (
      <Box marginTop="medium">
        <Text variant="text1" color="textSubtle">
          {subtitle}
        </Text>
      </Box>
    )}
  </>
);
